import { IRoom } from "../types/SiteLocation.types";
import apiFetch from './index';

export async function saveRoom(room: IRoom) {
    let url = '/api/rooms';
    if (room.Id !== undefined && room.Id !== -1) {
        url += `/${room.Id}`;
    }
    return await apiFetch(url, {
        method: 'POST',
        body: JSON.stringify(room),
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
}

export async function deleteRoom(id: number) {
    return await apiFetch(`/api/rooms/${id}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function getRoom(id: number) {
    return await apiFetch(`/api/rooms/${id}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function getCheckInRoomInfo(id: number) {
    return await apiFetch(`/api/rooms/${id}/check-in-info`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function getRoomInfo(id: number) {
    return await apiFetch(`/api/rooms/${id}/info`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function loadRooms() {
    const response = await apiFetch('/api/rooms', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
    return response;
}

export async function loadRoomsByApprover() {
    const response = await apiFetch(`/api/rooms/byApprover`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
    return response;
}

export async function loadRoomsBySite(id: number, abortController?: AbortController) {
    const response = await apiFetch(`/api/rooms/site/${id}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        signal: abortController?.signal
    });
    return response;
}

export async function loadRoomsByLocation(id: number, abortController?: AbortController) {
    const response = await apiFetch(`/api/rooms/location/${id}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        signal: abortController?.signal
    });
    return response;
}

export async function loadRoomsByLocationInclDisabled(id: number, abortController?: AbortController) {
    const response = await apiFetch(`/api/rooms/location/${id}/includeDisabled`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        signal: abortController?.signal
    });
    return response;
}

export async function getRoomAvailability(params: {
    fromDate: Date, toDate: Date, siteId?: number; locationId?: number; minCapacity?: number;
}, abortController: AbortController) {
    const response = await apiFetch(`/api/rooms/availability`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params),
        credentials: 'include',
        method: 'POST',
        signal: abortController.signal
    });
    return response;
}

export async function getRoomBookings(params: {
    roomId: number, fromDate: Date, toDate: Date
}, abortController: AbortController) {
    const response = await apiFetch(`/api/bookings/searchRooms`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
        credentials: 'include',
        method: 'POST',
        signal: abortController.signal
    });
    return response;
}

export async function getSiteRoomBookings(params: {
    siteId: number, fromDate: Date, toDate: Date
}, abortController: AbortController) {
    const response = await apiFetch(`/api/bookings/searchRooms`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
        credentials: 'include',
        method: 'POST',
        signal: abortController.signal
    });
    return response;
}